import {
  Typography,
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  createSearchParams,
  useNavigate,
  useSearchParams,
} from 'react-router-dom';
import { Reports } from './reports';
import FieldDetails from './fieldDetails';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { useGetReportsForFieldNumberQuery } from '../../../services/mVPGraphQlService';
import { Button } from '../../../components';
import React from 'react';

export const ReportDetailsMobile = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const fieldId = searchParams.get('fieldId');
  const type = searchParams.get('type');
  // const { type } = location.state || {};

  const [pageNo, setPageNo] = useState(1);

  const [openReportDetails, setOpenReportDetails] =
    useState(true);

  const user = useSelector(
    (state: RootState) => state.authUser
  );

  const { data, refetch } =
    useGetReportsForFieldNumberQuery(
      {
        fieldNo: Number(fieldId),
        actor: {
          actorId: user?.userId,
          actorName: user?.userName,
          actorType: user?.role,
        },
        pageSize: 5,
        pageNumber: pageNo,
      },
      {
        skip: !Number(fieldId),
      }
    );
  const [reports, setReportData] = useState<any | null>(
    null
  );
  const handleRefetch = async () => {
    const updatedData = await refetch();

    if (updatedData?.data?.data?.GetReportsForFieldNumber) {
      setReportData(
        updatedData?.data?.data?.GetReportsForFieldNumber
      );
    }
  };
  useEffect(() => {
    if (data?.data?.GetReportsForFieldNumber) {
      setReportData((prevData) => {
        if (!prevData)
          return data.data.GetReportsForFieldNumber;

        return {
          ...data.data.GetReportsForFieldNumber,
          reportDetails: [
            ...(prevData.reportDetails || []),
            ...(data.data.GetReportsForFieldNumber
              .reportDetails || []),
          ].filter(
            (report, index, self) =>
              index ===
              self.findIndex(
                (r) => r.reportId === report.reportId
              )
          ),
        };
      });
    }
  }, [data]);

  return (
    <div
      style={{
        padding: '20px',
        minHeight: '200px',

        paddingBottom: '200px',
      }}>
      <div style={{ display: 'flex' }}>
        <IconButton
          className="close-icon-btn"
          type="button"
          onClick={() =>
            type
              ? navigate(`/mvp/reports?tab=${type}`, {
                  replace: true,
                })
              : navigate(-1)
          }>
          <ArrowBackIcon className="close-icon" />
        </IconButton>
        <Typography
          style={{
            color: 'rgba(0, 0, 0, 1)',
            fontSize: '15px',
            fontWeight: 'bold',
            marginTop: 10,
          }}>
          {Number(fieldId)}
        </Typography>
      </div>

      <FieldDetails
        dataa={
          data?.data?.GetReportsForFieldNumber?.fieldDetails
        }
      />

      <Accordion
        expanded={openReportDetails}
        onChange={() =>
          setOpenReportDetails(!openReportDetails)
        }
        sx={{ marginTop: 2, marginBottom: '200px' }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography
            style={{
              fontSize: '13px',
              fontWeight: 'bold',
            }}>
            Report Details
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Reports
            setPageNo={setPageNo}
            pageNo={pageNo}
            data={reports}
            refetch={handleRefetch}
          />
        </AccordionDetails>
      </Accordion>

      {type === 'REQUESTED' &&
        reports?.reportDetails?.[0]?.assigneeActor
          ?.actorId == user?.userId && (
          <Button
            variant="button--primary"
            onClick={() =>
              navigate(
                {
                  pathname: '/mvp/createReport',
                  search: createSearchParams({
                    fieldId: fieldId?.toString() || '',
                    reportId:
                      reports?.reportDetails?.[0]?.reportId?.toString(),
                  }).toString(),
                },
                {
                  state: {
                    path: 'fromOthers',
                  },
                }
              )
            }
            type="submit"
            style={{
              position: 'fixed',
              bottom: 0,
              left: '50%',
              transform: 'translateX(-50%)',
              width: '100%',
              height: '50px',
              borderRadius: '0',
            }}>
            Write field report
          </Button>
        )}
    </div>
  );
};
